import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

export default [
    {
        name: "requestedAt",
        label: <FormattedMessage id="order.request-date" />,
        type: "date",
        errorMessage: <FormattedMessage id="order-form.err-msg-request-date" />,
        validation: {
            required: true,
        },
    },
    {
        name: "status",
        label: <FormattedMessage id="order.status" />,
        type: "select",
        errorMessage: <FormattedMessage id="order-form.err-msg-status" />,
        data: [
            { value: "requested", text: "Requested" },
            { value: "approved", text: "Approved" },
            { value: "rejected", text: "Rejected" },
            { value: "completed", text: "Completed" },
        ],
        validation: {
            required: true,
        },
    },
    {
        name: "projectId",
        label: <FormattedMessage id="order.project" />,
        type: "list",
        url: "/projects",
        filterValue: "name",
        filterResource: "filter[organization_id]=",
        filterWithId: "organizationId",
        include: true,
        entityName: "project",
    },
];
